import React from 'react'
import { ProductLights } from '../_shared/ProductLights'
import type { LightSpec, LightsProps } from '../types'

const rig: LightSpec[] = [
  { type: 'spot', position: [100, 200, 400], target: [0, 100, 0], intensity: 0.8, angle: 0.8, penumbra: 0.4, distance: 0, decay: 0, color: '#c8dcff', castShadow: true },
  { type: 'spot', position: [220, 200, 180], target: [0, 0, 0], intensity: 1, angle: 1, penumbra: 0.4, distance: 0, decay: 0, color: '#ffb46b', castShadow: true },
  { type: 'spot', position: [0, 300, 500], target: [0, 150, 0], intensity: 0.8, angle: 1, penumbra: 0.4, distance: 0, decay: 0, color: '#ffffff', castShadow: true },
  { type: 'ambient', intensity: 0.7, color: '#ffffff' },
  { type: 'spot', position: [0, 1000, 0], target: [0, 0, 0], intensity: 2, angle: 2, penumbra: 0.4, distance: 0, decay: 0, castShadow: true, shadowRadius: 4, color: '#ffb46b' },
]

export const Lights: React.FC<LightsProps> = (props) => (
  <ProductLights rig={rig} {...props} />
)
